import { Checkbox } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useBankStatementsStore } from "store/BankStatementsStore";

const BankStatementEntriesFilterBar = () => {
  const { t } = useTranslation();
  const [
    { includeHiddenEntries, includeNegativeAmounts },
    { setBankStatementsStoreValue },
  ] = useBankStatementsStore();

  const checkboxStyles = {
    label: { alignItems: "center" },
    checkbox: { width: 14, height: 14 },
    checkmark: { fontSize: 10, lineHeight: "12px" },
    text: { fontSize: 12, lineHeight: "14px" },
  };

  return (
    <div
      data-help="bank-statements-entry-filters"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "24px",
        padding: "6px 12px",
        borderTop: "1px solid rgba(128, 128, 128, 0.2)",
      }}
    >
      <Checkbox
        label={t("pct.includeNegativeAmounts.label")}
        checked={includeNegativeAmounts}
        styles={checkboxStyles}
        onChange={(ev, checked) => {
          localStorage.setItem(
            "bankStatementsIncludeNegativeAmounts",
            JSON.stringify(!!checked),
          );
          setBankStatementsStoreValue("includeNegativeAmounts", !!checked);
        }}
      />
      <Checkbox
        label={t("pct.includeHiddenEntries.label")}
        checked={includeHiddenEntries}
        styles={checkboxStyles}
        onChange={(ev, checked) => {
          localStorage.setItem(
            "bankStatementsIncludeHiddenEntries",
            JSON.stringify(!!checked),
          );
          setBankStatementsStoreValue("includeHiddenEntries", !!checked);
        }}
      />
    </div>
  );
};

export default BankStatementEntriesFilterBar;
